import React from "react"
import { T } from "../traks"

export const BinaryToggle = ({ name, checked, onChange, labels = [<T>Activate</T>, <T>Deactivate</T>], className = "" }) => {
  return (
    <div className={`ad_newgame_formgroup pt-2 ${className}`}>
      <div className="radio-item pr-lg-3">
        <input
          className="form-check-input"
          type="radio"
          id={`${name}_off`}
          name={name}
          checked={!checked}
          onChange={() => onChange({ target: { name, checked: false } })}
        />
        <label className="form-check-label ad_3px_radius" htmlFor={`${name}_off`}>
          {labels[1]}
        </label>
      </div>

      <div className="radio-item">
        <input
          className="form-check-input"
          type="radio"
          id={`${name}_on`}
          name={name}
          checked={checked}
          onChange={() => onChange({ target: { name, checked: true } })}
        />
        <label className="form-check-label ad_3px_radius" htmlFor={`${name}_on`}>
          {labels[0]}
        </label>
      </div>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/c/BinaryToggle.js